import { styled } from '@linaria/react';

export const GridContainer = styled.div<{
  numberOfExchanges: number;
  numberOfSportsbooks: number;
}>`
  display: grid;
  width: 100%;
  overflow-x: auto;
  grid-template-columns: ${props => {
    const columns = [
      '240px',
      '20px',
      `repeat(${props.numberOfSportsbooks}, calc(var(--ogm-grid-column-width) + var(--ogm-grid-cell-gap)))`,
    ];

    if (props.numberOfExchanges > 0) {
      columns.push('55px');
      columns.push(`repeat(${props.numberOfExchanges}, calc(var(--ogm-grid-column-width) + 1px))`);
    }

    return columns.join(' ');
  }};

  grid-auto-rows: auto;
  grid-column-gap: 0;
  grid-row-gap: 0;
`;

export const GridHeaderRow = styled.div`
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  align-items: center;
  overflow: visible;
`;

export const LeftColumn = styled.div`
  display: flex;
  padding-left: 15px;
  align-items: flex-start;
  background: var(--ogm-left-column-bg, transparent);
  height: 100%;
`;

export const OfferColumn = styled.div`
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--ogm-grid-column-height, 54px);
  border-bottom: 1px solid var(--ogm-border-color, #e0e0e0);
`;

export const BookmakerColumn = styled.div`
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--ogm-grid-column-height, 54px);
  border-bottom: 1px solid var(--ogm-border-color, #e0e0e0);
`;

export const BookmakerLogoColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  align-self: flex-end;
`;

export const BetNameColumn = styled.div`
  padding: 10px 0;
  display: flex;
  align-items: center;
  height: var(--ogm-grid-column-height, 54px);
  background: var(--ogm-left-column-bg, transparent);
`;

export const BetRow = styled.div`
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  align-items: center;
  height: var(--ogm-grid-column-height, 54px);

  ${BetNameColumn} {
    border-top: 1px solid var(--oc-border);
  }
  &:last-child {
    ${BetNameColumn} {
      border-bottom: 1px solid var(--oc-border);
    }
  }
`;

export const OffersLabel = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 1;
  color: var(--oc-text-subtext);
`;
